import { render, staticRenderFns } from "./NovoComponente.vue?vue&type=template&id=00a62733&"
import script from "./NovoComponente.vue?vue&type=script&lang=js&"
export * from "./NovoComponente.vue?vue&type=script&lang=js&"
import style0 from "./NovoComponente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports